import { render, staticRenderFns } from "./LayOutIndex.vue?vue&type=template&id=55c6bedc&scoped=true&"
import script from "./LayOutIndex.vue?vue&type=script&lang=js&"
export * from "./LayOutIndex.vue?vue&type=script&lang=js&"
import style0 from "./LayOutIndex.vue?vue&type=style&index=0&id=55c6bedc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c6bedc",
  null
  
)

export default component.exports